
/*
 *   File : payment-types.js
 *   Author URI : https://evoqins.com
 *   Description :Selecting payment method modal
 *   Integrations : null
 *   Version : v1.1
 */

// Packages
import React, { Fragment, useEffect, useState } from "react";

// Components
import { Icon } from "../Icon";
import { PrimaryButton } from "../Buttons";

// Custom styles
import Color from '../../Styles/color.module.scss';
import style from "../../Styles/Components/payment-type.module.scss";


const PaymentMethodModal = React.memo((props) => {

    const [paymentType, setPaymentType] = useState(props.payment_types[0].id);

    // handle payment type
    function _handlePayment(id) {
        setPaymentType(id);
    }

    async function _handleSubmit() {
        try {
            const result = await props.submit(paymentType);
            if (result) {
                document.getElementById("close-modal").dispatchEvent(new Event("click"));
                props.verifyOtp(paymentType)
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
        }
    }

    useEffect(() => {
        var my_modal = document.getElementById("payment-types");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.closeModal();

        });
        //eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <div className={`modal fade ${style.e_payment_modal}`}
                id="payment-types"
                tabIndex="-1"
                aria-labelledby="payment-types"
                aria-hidden="true"
                data-bs-backdrop="static"
                data-bs-keyboard="false" >
                <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                    <div className={`modal-content pb-4 ${style.e_content} `}>
                        <div className="border-bottom-1px border-ash-gray px-4">
                            <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                                <h5 className='e-font-16 mb-0 color-eerie-black e-montserrat-semi-bold e-line-height-24'>
                                    Select Payment Method
                                </h5>
                                <Icon icon="close-btn"
                                    size={24}
                                    color={Color.eerie_black}
                                    id="close-modal"
                                    className="cursor-pointer"
                                    data-bs-dismiss="modal" />
                            </div>
                        </div>
                        <div className="px-4 padding-14px-top">
                            <h6 className="e-font-16 mb-2 color-eerie-black e-montserrat-semi-bold e-line-height-24">
                                {
                                    props.selected === 1 ?
                                        <span> Make your payment of <span className="color-rebecca-purple">₹{props.amount}</span> to
                                            start SIP</span>
                                        :
                                        <span> Make your payment of <span className="color-rebecca-purple">₹{props.amount}</span> </span>
                                }
                            </h6>
                            <p className="color-dark-gray e-font-14 e-line-height-24 e-montserrat-medium pt-3 mb-2">
                                Payment method for first installment
                            </p>
                            {
                                props.payment_types.map((item, index) => {
                                    return (
                                        <div key={index}
                                            className={`py-2 padding-12px-lr d-flex align-items-center justify-content-between border-1px cursor-pointer mb-3 border-radius-12px  ${item.id === paymentType ? "border-purple e-bg-light-lavender" : "border-bright-gray"}`} onClick={() => _handlePayment(item.id)}>
                                            <div className="d-flex align-items-center gap-8px">
                                                <img src={item.image} alt={"Basket"}
                                                    draggable={false}
                                                    width={46}
                                                    height={32}
                                                />
                                                <span className="e-montserrat-semi-bold e-font-14 e-line-height-20 mb-0 color-eerie-black">
                                                    {item.label}
                                                </span>
                                            </div>
                                            <Icon icon={
                                                item.id === paymentType
                                                    ?
                                                    'radio-checked1' :
                                                    'radio-unchecked'
                                            }
                                                size={24} />
                                        </div>
                                    )
                                })
                            }

                            <div className="row d-flex justify-content-center">
                                <div className="col-6">
                                    <PrimaryButton label="Confirm"
                                        className="w-100 padding-10px-tb margin-40px-top"
                                        disabled={props.loader}
                                        onPress={_handleSubmit} />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
});

export default PaymentMethodModal